import { render, staticRenderFns } from "./admin-toll-free-registration.vue?vue&type=template&id=1dbf1057&scoped=true&"
import script from "./admin-toll-free-registration.vue?vue&type=script&lang=js&"
export * from "./admin-toll-free-registration.vue?vue&type=script&lang=js&"
import style0 from "./admin-toll-free-registration.vue?vue&type=style&index=0&id=1dbf1057&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dbf1057",
  null
  
)

export default component.exports